/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable radix */
/* eslint-disable no-dupe-keys */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-return-assign */
/* eslint-disable react/button-has-type */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ClearIcon from '@mui/icons-material/Clear';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';

import DiscountCode from 'renderer/features/purchase-page/components/DiscountCode';
import MainCard from 'renderer/features/purchase-page/components/MainCard';
import {
  useGetCartQuery,
  useUpdateCartItemMutation,
  useRemoveCartItemMutation,
  useValidateDiscountCodeMutation,
} from '../services/cart.endpoints';
import productThumbnails from '../../products-page/constants/productThumbnails';
// const CartPage = () => {

const CartPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: cart, isLoading, refetch } = useGetCartQuery(null);
  const [updateCartItem] = useUpdateCartItemMutation();
  const [removeCartItem] = useRemoveCartItemMutation();
  const [validateDiscountCode] = useValidateDiscountCodeMutation();

  // const [discountSummary, setDiscountSummary] = useState<CartPriceSummary | null>(null);
  type CartPriceSummary = {
    totalBeforeDiscount: number;
    totalDiscount: number;
    totalAfterDiscount: number;
  };
  const [discountSummary, setDiscountSummary] =
    useState<CartPriceSummary | null>(null);

  const [discountCode, setDiscountCode] = useState('');
  const [discountAmount, setDiscountAmount] = useState(0);
  const [step, setStep] = useState(1);

  // ──────────────────────────────────────────────────────────────
  // Helper utilities
  // ──────────────────────────────────────────────────────────────
  /** Returns the price that should actually be charged right now. */
  const getEffectivePrice = (product: any): number => {
    if (!product) return 0;

    const { fullPrice, sale } = product;
    const now = Date.now();

    // “On sale” if we have a sale object, a lower price, and it's not expired
    if (
      sale &&
      typeof sale.salePrice === 'number' &&
      sale.salePrice < fullPrice &&
      (!sale.until || new Date(sale.until).getTime() > now)
    ) {
      return sale.salePrice;
    }
    return fullPrice;
  };

  /** True iff the product is currently discounted. */
  const isOnSale = (product: any): boolean =>
    getEffectivePrice(product) !== product.fullPrice;

  const handleQuantityChange = (
    cartItemId: string,
    quantity: number,
    platform: any,
    hostApplication: any,
  ) => {
    updateCartItem({
      cartItemId,
      quantity,
      platform,
      hostApplication,
    });
  };

  const handleRemove = (cartItemId: string) => {
    removeCartItem({ cartItemId });
  };

  const handleDiscountApply = async () => {
    try {
      const res = await validateDiscountCode(discountCode).unwrap();
      if (res.valid && res.amount > 0) {
        setDiscountAmount(res.amount); // e.g. 0.25
      } else {
        setDiscountAmount(0);
        alert('Invalid or inapplicable discount code');
      }
    } catch (e) {
      setDiscountAmount(0);
      alert('Invalid or inapplicable discount code');
    }
  };

  const handleCheckout = () => {
    setStep(2);
    navigate('/purchase');
  };

  const items = cart?.items ?? [];
  console.log('items', items);

  const isAllAccess = (name: string) =>
    name?.toLowerCase().includes('all access');

  const hasMissingRequiredHostApp =
    cart?.items?.some(
      (item: any) =>
        !item.hostApplication?.id &&
        !item.productId?.name?.toLowerCase().includes('all access'),
    ) ?? false;

  // const subtotal = items.reduce((sum: number, item: any) => {
  //   return sum + item.productId.fullPrice * item.quantity;
  // }, 0);
  const subtotal = items.reduce(
    (sum: number, item: any) =>
      sum + getEffectivePrice(item.productId) * item.quantity,
    0,
  );

  const totalDiscount = items.reduce((sum: number, item: any) => {
    const discount = item.discountId;
    const price = item.productId.fullPrice;
    const qty = item.quantity;

    if (!discount) return sum;

    if (discount.amountUnits === 'percent') {
      return sum + price * qty * (discount.amount * 0.01);
    }

    if (discount.amountUnits === 'dollars') {
      return sum + discount.amount * qty;
    }

    return sum;
  }, 0);

  const total = subtotal - totalDiscount;

  if (!cart || isLoading) return <p>Loading...</p>;

  return (
    <div style={styles.container}>
      {/* Left - Cart Items */}
      <div style={styles.leftColumn}>
        <h2 style={styles.heading}>SHOPPING CART</h2>
        {items && items.length === 0 && (
          <p>There are no more items in your cart.</p>
        )}
        {!cart || isLoading ? (
          <p>Loading...</p>
        ) : (
          items.map((item: any) => {
            const image = productThumbnails.get(item.productId.productId) ?? '';
            const isItemAllAccess = item.productId.name
              ?.toLowerCase()
              .includes('all access');
            const isHostAppMissing =
              !item.hostApplication?.id && !isItemAllAccess;
            return (
              <div key={item.productId} style={styles.cartItem}>
                <img src={image} alt={item.name} style={styles.thumbnail} />
                <div style={styles.itemDetails}>
                  <p style={styles.productName}>{item.productId.name}</p>
                  {/* <p style={styles.price}>
                    ${item.productId.fullPrice.toFixed(2)}
                  </p> */}
                  <p style={styles.price}>
                    {isOnSale(item.productId) && (
                      <span style={styles.originalPrice}>
                        ${item.productId.fullPrice.toFixed(2)}
                      </span>
                    )}
                    ${getEffectivePrice(item.productId).toFixed(2)}
                  </p>

                  <div style={styles.meta}>
                    <label>
                      <span style={styles.metaLabel}>Platform:</span>
                      <select
                        value={item.platform}
                        onChange={(e) =>
                          updateCartItem({
                            cartItemId: item._id,
                            productId: item.productId._id || item.productId,
                            quantity: item.quantity,
                            platform: e.target.value,
                            hostApplication: item.hostApplication,
                          })
                        }
                        style={styles.select}
                      >
                        <option value="Windows">Windows</option>
                        <option value="Macintosh">Macintosh</option>
                      </select>
                    </label>
                    <label>
                      <span style={styles.metaLabel}>Host App:</span>
                      <div>
                        <select
                          value={item.hostApplication?.id ?? ''}
                          onChange={(e) => {
                            const selectedApp =
                              item.productId.supportedHostApplications?.find(
                                (app: any) => app.id === e.target.value,
                              );

                            updateCartItem({
                              cartItemId: item._id,
                              productId: item.productId._id || item.productId,
                              quantity: item.quantity,
                              platform: item.platform,
                              hostApplication: selectedApp
                                ? {
                                    id: selectedApp.id,
                                    displayName: selectedApp.displayName,
                                    version: selectedApp.version,
                                  }
                                : null,
                            });
                          }}
                          style={{
                            padding: '6px',
                            borderRadius: '4px',
                            marginTop: '6px',
                            borderColor: isHostAppMissing ? 'red' : undefined,
                            borderWidth: isHostAppMissing ? '2px' : undefined,
                            borderStyle: isHostAppMissing ? 'solid' : undefined,
                          }}
                        >
                          <option value="">Select Host App...</option>
                          {(item.productId.supportedHostApplications || []).map(
                            (app: any) => (
                              <option key={app.id} value={app.id}>
                                {app.displayName}
                              </option>
                            ),
                          )}
                        </select>

                        {isHostAppMissing && (
                          <div
                            style={{
                              color: 'red',
                              fontSize: '12px',
                              marginTop: '4px',
                            }}
                          >
                            Please select a Host App before proceeding.
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
                <div style={styles.itemControls}>
                  <span style={{ fontWeight: 'bold', fontSize: 14 }}>
                    Quantity:
                  </span>
                  <input
                    type="number"
                    min="0"
                    value={item.quantity}
                    onChange={(e) =>
                      handleQuantityChange(
                        // item.productId._id || item.productId,
                        item._id,
                        Math.max(0, parseInt(e.target.value) || 0),
                        item.platform,
                        item.hostApplication,
                      )
                    }
                    style={styles.quantityInput}
                  />
                  {/* <p style={styles.lineItemPrice}>
                    ${(item.productId.fullPrice * item.quantity).toFixed(2)}
                  </p> */}
                  <p style={styles.lineItemPrice}>
                    $
                    {(
                      getEffectivePrice(item.productId) * item.quantity
                    ).toFixed(2)}
                  </p>

                  <Tooltip title="Remove item" arrow>
                    <IconButton
                      onClick={() => handleRemove(item._id)}
                      size="small"
                      aria-label="Remove item"
                    >
                      <ClearIcon color="error" />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            );
          })
        )}

        <button
          style={{ ...styles.linkButton, marginTop: '20px' }}
          onClick={() => (window.location.href = '/#/')}
        >
          ◀ Continue shopping
        </button>
      </div>

      {/* Right - Summary + Checkout */}
      <div style={styles.rightColumn}>
        <div style={styles.summaryBox}>
          <h2 style={styles.heading}>SUMMARY</h2>
          <div style={{ marginBottom: '12px' }}>
            {items.map((item: any) => {
              const { name } = item.productId;
              const { quantity } = item;
              // const price = item.productId.fullPrice;
              // const lineTotal = price * quantity;
              const price = getEffectivePrice(item.productId);
              const lineTotal = price * quantity;

              return (
                <div
                  key={item.productId._id || item.productId}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '0.9rem',
                    lineHeight: '1.4',
                    padding: '4px 0',
                    gap: '8px',
                  }}
                >
                  <span style={{ color: '#333', flex: 1 }}>
                    {name} × {quantity}
                  </span>
                  <span style={{ color: '#333', whiteSpace: 'nowrap' }}>
                    ${lineTotal.toFixed(2)}
                  </span>
                </div>
              );
            })}
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '4px',
            }}
          >
            <span>Subtotal:</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>

          {totalDiscount > 0 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                color: 'green',
                marginBottom: '4px',
              }}
            >
              <span>Discounts:</span>
              <span>-${totalDiscount.toFixed(2)}</span>
            </div>
          )}

          <hr style={{ margin: '8px 0' }} />

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontWeight: 'bold',
              fontSize: '16px',
            }}
          >
            <span>Total:</span>
            <span>${total.toFixed(2)}</span>
          </div>

          <Stack justifyContent="flex-end" spacing={1} sx={{ mt: 2 }}>
            <Stack justifyContent="flex-end">
              {/* <DiscountCode onDiscountUpdate={setDiscountSummary} /> */}
              <DiscountCode
                onDiscountUpdate={(summary) => {
                  setDiscountSummary(summary);
                  refetch(); //  triggers the updated cart to reload
                }}
              />
            </Stack>
          </Stack>

          <button
            onClick={() => {
              if (hasMissingRequiredHostApp) return; // silently block or show toast/modal
              handleCheckout();
            }}
            style={{
              ...styles.checkoutButton,
              opacity: hasMissingRequiredHostApp ? 0.6 : 1,
              cursor: hasMissingRequiredHostApp ? 'not-allowed' : 'pointer',
            }}
          >
            PROCEED TO CHECKOUT
          </button>
        </div>

        <div style={styles.supportBox}>
          <p>
            <b>Trouble Checking Out?</b>
          </p>
          <p>
            You can also purchase at{' '}
            <a
              href="https://store.digitalanarchy.com"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none' }}
            >
              store.digitalanarchy.com
            </a>{' '}
            or contact us.
          </p>
          <p>
            📞 <b>415-287-6069</b>, 10am–5pm PST
          </p>
          <p>
            <b>Digital Downloads</b>
          </p>
          <p>
            All products/invoices are emailed to you. Check spam! Don&apos;t see
            it? Email <b>sales@digitalanarchy.com</b>.
          </p>
        </div>
      </div>
    </div>
  );
};

// 💅 Inline Styles
const styles: Record<string, React.CSSProperties> = {
  // container: {
  //   display: 'flex',
  //   gap: '30px',
  //   maxWidth: '1200px',
  //   margin: '0 auto',
  //   padding: '30px',
  //   fontFamily: 'Arial, sans-serif',
  //   alignItems: 'flex-start',
  // },
  container: {
    display: 'flex',
    gap: '30px',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '30px',
    fontFamily: 'Arial, sans-serif',
    alignItems: 'flex-start',
    backgroundColor: '#f7f7f7', // 🔹 New background
    borderRadius: '8px',
  },

  heading: {
    marginTop: '0',
    marginBottom: '25px',
    fontSize: '24px',
    fontWeight: 'bold',
    borderBottom: '1px solid #ccc',
  },
  // leftColumn: {
  //   flex: 2,
  // },
  // rightColumn: {
  //   flex: 1,
  // },
  leftColumn: {
    flex: 2,
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  rightColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },

  cartItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '20px',
    borderBottom: '1px solid #ccc',
    paddingBottom: '15px',
  },
  thumbnail: {
    width: 115,
    height: 115,
    marginRight: 20,
    objectFit: 'contain' as React.CSSProperties['objectFit'],
    border: '1px solid #ccc',
  },
  itemDetails: {
    flexGrow: 1,
  },
  productName: {
    marginTop: '3px',
    fontWeight: 'bold',
    marginBottom: '4px',
  },
  price: {
    marginTop: '4px',
    color: '#08c',
    marginBottom: '6px',
  },
  // meta: {
  //   marginTop: '4px',
  //   fontSize: '0.9rem',
  //   color: '#444',
  // },
  // itemControls: {
  //   display: 'flex',
  //   flexDirection: 'column',
  //   alignItems: 'center',
  //   gap: '6px',
  // },

  itemControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginTop: '8px',
  },

  quantityInput: {
    width: '60px',
    padding: '4px 6px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },

  lineItemPrice: {
    fontWeight: 'bold',
    fontSize: '15px',
  },
  originalPrice: {
    textDecoration: 'line-through',
    opacity: 0.6,
    marginRight: '6px',
  },

  trashButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    color: '#333',
  },

  quantitySelect: {
    padding: '4px',
    borderRadius: '4px',
  },
  // trashButton: {
  //   background: 'none',
  //   border: 'none',
  //   cursor: 'pointer',
  //   fontSize: '18px',
  // },
  linkButton: {
    background: 'none',
    color: '#08c',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
  },
  // summaryBox: {
  //   border: '1px solid #ddd',
  //   borderRadius: '8px',
  //   padding: '20px',
  //   marginBottom: '20px',
  // },
  summaryBox: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  discountArea: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  input: {
    width: '100%',
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    marginTop: '5px',
  },
  checkoutButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#00a9e0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    marginTop: '20px',
  },
  // supportBox: {
  //   fontSize: '0.9rem',
  //   color: '#333',
  // },
  supportBox: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    fontSize: '0.9rem',
    color: '#333',
  },
  // select: {
  //   padding: '4px 8px',
  //   fontSize: '14px',
  //   marginLeft: '8px',
  //   border: '1px solid #ccc',
  //   borderRadius: '4px',
  // },

  meta: {
    marginTop: '4px',
    fontSize: '0.9rem',
    color: '#444',
    lineHeight: 1.4,

    /* NEW — lay out the two rows nicely */
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },

  /* shared <select> decoration */
  select: {
    marginLeft: '6px',
    padding: '3px 6px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    background: '#fff',
  },

  /* optional: makes the bold label (<b>) align with the select */
  metaLabel: {
    fontWeight: 600,
    minWidth: '72px', // keeps the text width consistent
    display: 'inline-block',
  },
};

export default CartPage;
